export default {
  "None": 0,
  "Custom": 1,
  "SOS": 2,
  "ElectricCutoff": 4,
  "InGeoFance": 8,
  "OutGeoFance": 16,
  "HighSpeed": 32,
  "LowSpeed": 64,
  "Theft": 128,
  "Vibrate": 256,
  "LowPower": 512,
  "Moving": 1024,
  "Fire": 2048,
  "MedicalHelp": 4096,
  "Defence": 8192,
  "Destroy": 16384,
  "ACCON": 32768,
  "ACCOFF": 65536,
  "INPUT1": 131072,
  "INPUT2": 262144,
  "INPUT1_LOW": 524288,
  "INPUT2_LOW": 1048576,
  "HardBrake": 2097152,
  "LowTemp": 4194304,
  "HighTemp": 8388608,
  "FatigueDriving": 16777216,
  "Accelerate": 33554432,
  "Offline": 67108864,
  "INPUT3": 134217728,
  "INPUT3_OFF": 268435456,
  "INPUT4": 536870912,
  "INPUT4_OFF": 1073741824,
}